import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import type { AtVirtualClinicSaps3ChirurgischerStatus } from '@bindoc-projects/virtual-clinic-domain-lib';

export const AT_SAPS3_CHIRURGISCHER_STATUS_CONDITION_ID =
  'saps3ChirurgischerStatus';
export const AtFilterConditionSaps3ChirurgischerStatusPluginType: FilterConditionPluginSpecification<
  AtVirtualClinicSaps3ChirurgischerStatus[],
  AtFilterConditionSaps3ChirurgischerStatusDto,
  AtSaps3ChirurgischerStatusCondition
> = {
  type: 'saps3ChirurgischerStatus',
  category: 'case',
  displayName: { de: 'SAPS3: Chirurgischer Status' },
  sortingIndex: 20,
  occurrence: 'single',
  fromObject(
    obj: AtFilterConditionSaps3ChirurgischerStatusDto,
  ): FilterConditionPluginImpl<AtVirtualClinicSaps3ChirurgischerStatus[]> {
    return new AtFilterConditionSaps3ChirurgischerStatusPlugin(
        obj.saps3ChirurgischerStatus,
      );
  },
  fromCondition(
    jsonObj: AtSaps3ChirurgischerStatusCondition,
  ): FilterConditionPluginImpl<AtVirtualClinicSaps3ChirurgischerStatus[]> {
    return new AtFilterConditionSaps3ChirurgischerStatusPlugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<AtVirtualClinicSaps3ChirurgischerStatus[]> {
    return new AtFilterConditionSaps3ChirurgischerStatusPlugin([]);
  },
};

export class AtFilterConditionSaps3ChirurgischerStatusPlugin extends FilterConditionPluginImpl<
  AtVirtualClinicSaps3ChirurgischerStatus[],
  AtFilterConditionSaps3ChirurgischerStatusDto
> {
  static override Specification: FilterConditionPluginSpecification<
    AtVirtualClinicSaps3ChirurgischerStatus[],
    AtFilterConditionSaps3ChirurgischerStatusDto,
    AtSaps3ChirurgischerStatusCondition
  > = AtFilterConditionSaps3ChirurgischerStatusPluginType;

  constructor(
    protected saps3ChirurgischerStatus: AtVirtualClinicSaps3ChirurgischerStatus[],
  ) {
    super(AtFilterConditionSaps3ChirurgischerStatusPluginType.type);
  }

  clone(): AtFilterConditionSaps3ChirurgischerStatusPlugin {
    return new AtFilterConditionSaps3ChirurgischerStatusPlugin([
      ...this.saps3ChirurgischerStatus,
    ]);
  }

  override equals(
    other: AtFilterConditionSaps3ChirurgischerStatusPlugin,
  ): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(
        this.saps3ChirurgischerStatus,
        other.saps3ChirurgischerStatus,
      )
    );
  }

  override validationToText(): string {
    if (this.saps3ChirurgischerStatus.length === 0) {
      return 'Mindestens einen Status auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new AtSaps3ChirurgischerStatusCondition(
        this.saps3ChirurgischerStatus,
        [],
      );
  }

  toText(): string | null {
    return this.saps3ChirurgischerStatus.length === 1
      ? 'ein chirurgischer Status'
      : `${this.saps3ChirurgischerStatus.length} chirurgische Status`;
  }

  toJSON(): AtFilterConditionSaps3ChirurgischerStatusDto | null {
    return {
      type: this.type,
      saps3ChirurgischerStatus: this.saps3ChirurgischerStatus,
    };
  }

  toValue(): AtVirtualClinicSaps3ChirurgischerStatus[] {
    return this.saps3ChirurgischerStatus;
  }
}

export class AtSaps3ChirurgischerStatusCondition extends BdContentCondition<AtVirtualClinicSaps3ChirurgischerStatus> {
  constructor(
    includes: AtVirtualClinicSaps3ChirurgischerStatus[],
    excludes: AtVirtualClinicSaps3ChirurgischerStatus[],
  ) {
    super(AT_SAPS3_CHIRURGISCHER_STATUS_CONDITION_ID, includes, excludes);
  }
}

interface AtFilterConditionSaps3ChirurgischerStatusDto {
  type: string;
  saps3ChirurgischerStatus: AtVirtualClinicSaps3ChirurgischerStatus[];
}
